import {
    Box,
    Card,
    Flex,
    Skeleton,
    SkeletonCircle,
    VStack,
} from "@chakra-ui/react";

const skeletonProps = {
    bg: "#DAE9FF",
    borderRadius: "md",
};

const cardProps = {
    bg: "white",
    border: "none",
    borderWidth: 0,
    boxShadow: "sm",
    borderRadius: "2xl",
};

const SearchSkeleton = () => (
    <Card.Root {...cardProps}>
        <Card.Body
            p={{
                base: 4,
                md: 8,
            }}
        >
            <Skeleton
                {...skeletonProps}
                h="28px"
                w={{
                    base: "180px",
                    md: "260px",
                }}
                mb={4}
            />

            <Skeleton
                {...skeletonProps}
                h="16px"
                w={{
                    base: "100%",
                    md: "480px",
                }}
                mb={6}
            />

            <Skeleton
                {...skeletonProps}
                h="48px"
                w="100%"
                borderRadius="xl"
            />
        </Card.Body>
    </Card.Root>
);

const FAQItemSkeleton = () => (
    <Flex
        direction={{
            base: "column",
            md: "row",
        }}
        align={{
            base: "flex-start",
            md: "center",
        }}
        justify="space-between"
        gap={{
            base: 4,
            md: 0,
        }}
        py={5}
        borderBottom="1px solid"
        borderColor="gray.100"
    >
        <Flex
            flex={1}
            align="center"
            gap={4}
            w="100%"
        >
            <SkeletonCircle
                bg="#DAE9FF"
                size="8"
            />

            <Box flex={1}>
                <Skeleton
                    {...skeletonProps}
                    h="16px"
                    w="80%"
                    mb={3}
                />

                <Skeleton
                    {...skeletonProps}
                    h="12px"
                    w="100%"
                    mb={2}
                />

                <Skeleton
                    {...skeletonProps}
                    h="12px"
                    w="85%"
                />
            </Box>
        </Flex>

        <Skeleton
            {...skeletonProps}
            h="28px"
            w="28px"
            borderRadius="full"
        />
    </Flex>
);

const FAQListSkeleton = () => (
    <Card.Root {...cardProps}>
        <Card.Body
            p={{
                base: 5,
                md: 8,
            }}
        >
            <Skeleton
                {...skeletonProps}
                h="28px"
                w={{
                    base: "220px",
                    md: "320px",
                }}
                mb={3}
            />

            <Skeleton
                {...skeletonProps}
                h="14px"
                w={{
                    base: "100%",
                    md: "450px",
                }}
                mb={8}
            />

            <VStack
                align="stretch"
                gap={0}
            >
                {Array.from({
                    length: 7,
                }).map((_, i) => (
                    <FAQItemSkeleton
                        key={i}
                    />
                ))}
            </VStack>
        </Card.Body>
    </Card.Root>
);

const SupportCardSkeleton = () => (
    <Card.Root {...cardProps}>
        <Card.Body
            p={{
                base: 4,
                md: 6,
            }}
        >
            <Flex
                direction={{
                    base: "column",
                    md: "row",
                }}
                justify="space-between"
                align={{
                    base: "flex-start",
                    md: "center",
                }}
                gap={4}
            >
                <Box flex={1}>
                    <Skeleton
                        {...skeletonProps}
                        h="24px"
                        w="220px"
                        mb={3}
                    />

                    <Skeleton
                        {...skeletonProps}
                        h="12px"
                        w="100%"
                        mb={2}
                    />

                    <Skeleton
                        {...skeletonProps}
                        h="12px"
                        w="80%"
                    />
                </Box>

                <Skeleton
                    {...skeletonProps}
                    h="42px"
                    w={{
                        base: "100%",
                        md: "160px",
                    }}
                />
            </Flex>
        </Card.Body>
    </Card.Root>
);

export default function FAQSkeleton() {
    return (
        <>
            {/* Header */}

            <Box
                mb={{
                    base: 6,
                    md: 8,
                }}
            >
                <Skeleton
                    {...skeletonProps}
                    h="36px"
                    w={{
                        base: "210px",
                        md: "300px",
                    }}
                    mb={3}
                />

                <Skeleton
                    {...skeletonProps}
                    h="16px"
                    w={{
                        base: "100%",
                        md: "600px",
                    }}
                />
            </Box>

            {/* Search */}

            <SearchSkeleton />

            {/* FAQ List */}

            <Box
                mt={{
                    base: 6,
                    md: 8,
                }}
            >
                <FAQListSkeleton />
            </Box>

            {/* Bottom Card */}

            <Box
                mt={{
                    base: 6,
                    md: 8,
                }}
            >
                <SupportCardSkeleton />
            </Box>
        </>
    );
}